<palantir-content class="palantir-dialog">
  <palantir-layout>
    <palantir-toolbar palantir-layout-header>
      <palantir-toolbar-main>
        @if (title) {
          <palantir-text size="lg" type="title">{{ title }}</palantir-text>
        }
        <ng-content select="[palantir-dialog-header], palantir-dialog-header" />
      </palantir-toolbar-main>

      <palantir-toolbar-suffix>
        <palantir-button
          theme="transparent"
          layout="icon"
          shape="rounded"
          size="xs"
          icon="close-outline"
          (click)="close()"
        />
      </palantir-toolbar-suffix>
    </palantir-toolbar>

    <ng-content select="[palantir-dialog-content], palantir-dialog-content" />
    <ng-content />

    <ng-content select="[palantir-dialog-actions], palantir-dialog-actions" />
  </palantir-layout>
</palantir-content>
